export default __webpack_public_path__ + "static/media/hierarchy.8951fcfc.svg";